module.exports = __webpack_public_path__ + "static/jobs-7cf0336adaa2a250680907a83a7ecba3.jpg";